import { enableMapSet } from "immer";
import React from "react";
import ReactDOM from "react-dom/client";

import ApiHandler from "./apis/ApiHandler";
import "./common/styles/global.scss";
import { CartProvider } from "./contexts/CartServiceContext/CartServiceContext";
import { CatalogueProvider } from "./contexts/CatalogueContext/CatalogueContext";
import { ConfigProvider } from "./contexts/ConfigContext/ConfigContext";
import { PaymentProvider } from "./contexts/PaymentContext/PaymentContext";
import { PreloadProvider } from "./contexts/PreloadContext/PreloadProvider";
import "./i18n";
import App from "./router/App";
import { initializeDatadogRUM } from "./services/datadog";
import { trackRawViewport } from "./services/viewportTracker";

const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

enableMapSet();

// Initialize Datadog RUM
const initDatadog = async () => {
	try {
		await initializeDatadogRUM({
			applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
			clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
		});
	} catch (error) {
		console.error(
			"Failed to initialize Datadog RUM:",
			error,
			"VITE_DATADOG_APPLICATION_ID:",
			import.meta.env.VITE_DATADOG_APPLICATION_ID,
			"VITE_DATADOG_CLIENT_TOKEN:",
			import.meta.env.VITE_DATADOG_CLIENT_TOKEN
		);
	}
};

function render(AppComponent: React.FC) {
	root.render(
		<PreloadProvider>
			<ConfigProvider>
				<CatalogueProvider>
					<CartProvider>
						<PaymentProvider>
							<ApiHandler />
							<AppComponent />
						</PaymentProvider>
					</CartProvider>
				</CatalogueProvider>
			</ConfigProvider>
		</PreloadProvider>
	);
}

// Initialize Datadog asynchronously and then render
initDatadog().then(() => {
	trackRawViewport();
	render(App);
});

if (import.meta.hot) {
	import.meta.hot.accept("./router/App", (newModule) => {
		const NextApp = newModule.default;

		render(NextApp);
	});
}
